"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sepolia = void 0;
exports.sepolia = {
    "addresses": {
        "ProxyAdmin": "0xa6407A9D9C2fFd4eb83B2cD65F8A21239d2d7D81",
        "Sumer": "0x875432296283C6e6E85dfFB6b3F4f16EE1c35913",
        "CompoundLens": "0x5633F7E77532512fE88cee98B2a9740D4D4e927C",
        "CompLogic": "0xBc4B5851d8a08F5Ab161b27313EaAFf19612379D",
        "RedemptionManager": "0xD3BD3ea70bFF403354Bf6d917BB4AEaf6B23E802",
        "Timelock": "0x406dFd83031A11a751da718FF5E755485F57C306",
        "Comptroller": "0x0613b6a19699E6FA40Ca5e62C82b389c817bfA40",
        "sdrETH": "0xa6e643cAC98CE52579527491C9850fb975462A40",
        "ETH": "0x0000000000000000000000000000000000000000",
        "CErc20": "0xb2c2996362B4fD37D4c6b75d1a1673ac3720cC1A",
        "suErc20": "0xC1E1bA304128d30a170b278217477AEfBf93814a",
        "CAavePool": "0xd625856606d5DB9a791B43A06B59318B9D118009",
        "CAToken": "0x7DD917886462Da827DFBd98d5d11Dea3133DDAf0",
        "JumpRate#1": "0x0555999470190c734469CB0C2c07b80cC1fC9aeF",
        "ZeroRate": "0xA3a19c0E02Eb87d8A3057e049bDF7CCb21F79a26",
        "sdrUSDC": "0xEbD09f0b608231fcD0B67819e6D98e6292f3d8d4",
        "USDC": "0xD6e37B08308bFfe239f8C31F38EF4B4a0BB4e9b1",
        "sdrUSDT": "0xB712456DA13DdA8707B6C1d04F0CF9D439599491",
        "USDT": "0x162e8E6963C72Af93d69639eA9aB220498384c78",
        "sdrsuUSD": "0x6605B0f576604fe9f17a8C2A07Bb32Bf847e3da3",
        "suUSD": "0x7215b1853E846dBB6B4F5639563be5E2f1A9489f",
        "sdrUSDC_Aave": "0x792C15b6b423F2CA264d0bb199cAc2D9e2ddD9AE",
        "USDC_Aave": "0x94a9D9AC8a22534E3FaCa9F4e7F2E2cf85d5E4C8",
        "FeedPriceOracle": "0x33e89ed3e9B366C084350FeDb7b4ec7058Ed4762",
        "sdraUSDC": "0x3a8427C5409A9214C304df3d79A9ea91DFdA386d",
        "aUSDC": "0x94a9d9ac8a22534e3faca9f4e7f2e2cf85d5e4c8"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0xEbD09f0b608231fcD0B67819e6D98e6292f3d8d4",
            "underlySym": "USDC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xD6e37B08308bFfe239f8C31F38EF4B4a0BB4e9b1",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "0xB712456DA13DdA8707B6C1d04F0CF9D439599491",
            "underlySym": "USDT",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x162e8E6963C72Af93d69639eA9aB220498384c78",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0x6605B0f576604fe9f17a8C2A07Bb32Bf847e3da3",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x7215b1853E846dBB6B4F5639563be5E2f1A9489f",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDC_Aave",
            "ctokenAddr": "0x792C15b6b423F2CA264d0bb199cAc2D9e2ddD9AE",
            "underlySym": "USDC_Aave",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x94a9D9AC8a22534E3FaCa9F4e7F2E2cf85d5E4C8",
            "assetGroupId": 1,
            "aaveV3PoolAddr": "0x6Ae43d3271ff6888e7Fc43Fd7321a503ff738951"
        },
        {
            "ctokenSym": "sdraUSDC",
            "ctokenAddr": "0x3a8427C5409A9214C304df3d79A9ea91DFdA386d",
            "underlySym": "aUSDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x94a9d9ac8a22534e3faca9f4e7f2e2cf85d5e4c8",
            "assetGroupId": 1,
            "aaveV3PoolAddr": "0x6Ae43d3271ff6888e7Fc43Fd7321a503ff738951"
        },
        {
            "ctokenSym": "sdrETH",
            "ctokenAddr": "0xa6e643cAC98CE52579527491C9850fb975462A40",
            "underlySym": "ETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#1",
            "contract": "JumpRateModelV2",
            "address": "0x0555999470190c734469CB0C2c07b80cC1fC9aeF",
            "tokens": [
                "ETH",
                "USDC",
                "USDT",
                "USDC_Aave",
                "aUSDC",
                "ETH"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.1",
            "jumpMultiplierPerYear": "3",
            "kink": "0.65"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0xA3a19c0E02Eb87d8A3057e049bDF7CCb21F79a26",
            "tokens": [
                "suUSD"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=sepolia.js.map